import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import { TooltipsService } from '../../services/tooltips.service';
import { AnalyticsService } from '../../services/analytics.service';
import './unsubscribe.component.scss';
var Unsubscribe = /** @class */ (function (_super) {
    tslib_1.__extends(Unsubscribe, _super);
    function Unsubscribe(element) {
        return _super.call(this, element) || this;
    }
    Unsubscribe.prototype.init = function () {
        this.containerUnsubscribe = this.element.querySelector('.unsubscribe__container--change');
        this.containerNotValid = this.element.querySelector('.unsubscribe__container--notvalid');
        this.containerChanged = this.element.querySelector('.unsubscribe__container--changed');
        this.containerCancelled = this.element.querySelector('.unsubscribe__container--cancelled');
        this.containerLoader = this.element.querySelector('.unsubscribe__container--loader');
        this.checkboxes = Array.from(this.element.querySelectorAll('.js-newsletter-modal-checkbox'));
        this.btnChange = this.element.querySelector('.unsubscribe__button--change');
        this.btnUnsubscribe = this.element.querySelector('.unsubscribe__button--unsubscribe');
        this.checkboxesSelected = [];
        TooltipsService.initTooltips();
    };
    Unsubscribe.prototype.bindEvents = function () {
        var _this = this;
        this.btnChange.addEventListener('click', function (event) {
            var element = event.target;
            var form = element.closest('form');
            _this.unsubscribeTopics(form);
        });
        this.btnUnsubscribe.addEventListener('click', function (event) {
            var element = event.target;
            var form = element.closest('form');
            _this.unsubscribe(form);
        });
    };
    Unsubscribe.prototype.unsubscribeTopics = function (form) {
        var _this = this;
        this.containerUnsubscribe.classList.remove('d-block');
        this.containerNotValid.classList.remove('d-block');
        this.containerChanged.classList.remove('d-block');
        this.containerCancelled.classList.remove('d-block');
        this.containerLoader.classList.add('d-block');
        var operation = "unsubscribe_topics";
        var formId = form.querySelector('input.js-unsubscribe-formid').value;
        var subId = form.querySelector('input.js-unsubscribe-subid').value;
        var siteName = form.querySelector('input.js-unsubscribe-sitename').value;
        var mcJobId = form.querySelector('input.js-unsubscribe-mcjobid').value;
        var mcBatchId = form.querySelector('input.js-unsubscribe-mcbatchid').value;
        var topics = "";
        var topicsDataLayer = "";
        this.checkboxes.map(function (item) {
            if (item.checked) {
                _this.checkboxesSelected.push(item.value);
            }
        });
        var arrayCheckboxesEmpty = [];
        for (var index = 0; index < this.checkboxesSelected.length; index++) {
            var topic = this.checkboxesSelected[index];
            if (!arrayCheckboxesEmpty.includes(topic)) {
                if ((index + 1) === this.checkboxesSelected.length) {
                    topics += topic;
                    topicsDataLayer += topic;
                    arrayCheckboxesEmpty.push(topic);
                }
                else {
                    topics += topic + ",";
                    topicsDataLayer += topic + ":";
                    arrayCheckboxesEmpty.push(topic);
                }
            }
        }
        dataLayer.formOptions = topicsDataLayer;
        var postData = '';
        if (operation) {
            postData += 'operation=' + operation + '&';
        }
        if (formId) {
            postData += 'formId=' + formId + '&';
        }
        if (subId) {
            postData += 'subId=' + subId + '&';
        }
        if (siteName) {
            postData += 'site=' + siteName + '&';
        }
        if (topics) {
            postData += 'topics=' + topics + '&';
        }
        if (mcJobId) {
            postData += 'mcJobID=' + mcJobId + '&';
        }
        if (mcBatchId) {
            postData += 'mcBatchID=' + mcBatchId + '&';
        }
        postData += 'optOut=';
        var analyticsService = new AnalyticsService();
        var url = "/services/NewsLetterSubscription.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, postData, config).then(function (response) {
            _this.containerLoader.classList.remove('d-block');
            if (response.data.result) {
                var result = response.data.result;
                if (result.indexOf('updated') !== -1) {
                    analyticsService.dtmFormComplete('complete', response.data.subscriberId);
                    _this.containerUnsubscribe.classList.remove('d-block');
                    _this.containerChanged.classList.add('d-block');
                }
                else {
                    _this.containerUnsubscribe.classList.remove('d-block');
                    _this.containerNotValid.classList.add('d-block');
                }
            }
            else {
                _this.containerUnsubscribe.classList.remove('d-block');
                _this.containerNotValid.classList.add('d-block');
            }
        }).catch(function (error) {
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            console.log(error);
            _this.containerLoader.classList.remove('d-block');
            _this.containerUnsubscribe.classList.remove('d-block');
            _this.containerNotValid.classList.add('d-block');
        });
    };
    Unsubscribe.prototype.unsubscribe = function (form) {
        var _this = this;
        this.containerUnsubscribe.classList.remove('d-block');
        this.containerNotValid.classList.remove('d-block');
        this.containerChanged.classList.remove('d-block');
        this.containerCancelled.classList.remove('d-block');
        this.containerLoader.classList.add('d-block');
        var operation = "unsubscribe";
        var formId = form.querySelector('input.js-unsubscribe-formid').value;
        var subId = form.querySelector('input.js-unsubscribe-subid').value;
        var siteName = form.querySelector('input.js-unsubscribe-sitename').value;
        var mcJobId = form.querySelector('input.js-unsubscribe-mcjobid').value;
        var mcBatchId = form.querySelector('input.js-unsubscribe-mcbatchid').value;
        var postData = '';
        if (operation) {
            postData += 'operation=' + operation + '&';
        }
        if (formId) {
            postData += 'formId=' + formId + '&';
        }
        if (subId) {
            postData += 'subId=' + subId + '&';
        }
        if (siteName) {
            postData += 'site=' + siteName + '&';
        }
        if (mcJobId) {
            postData += 'mcJobID=' + mcJobId + '&';
        }
        if (mcBatchId) {
            postData += 'mcBatchID=' + mcBatchId + '&';
        }
        postData += 'optOut=';
        var analyticsService = new AnalyticsService();
        var url = "/services/NewsLetterSubscription.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, postData, config).then(function (response) {
            _this.containerLoader.classList.remove('d-block');
            if (response.data.result) {
                var result = response.data.result;
                if (result.indexOf('unsubscribed') !== -1) {
                    if (localStorage.getItem('sbgNewsletterSubscriberId')) {
                        localStorage.removeItem('sbgNewsletterSubscriberId');
                    }
                    analyticsService.dtmFormComplete('complete', response.data.subscriberId);
                    _this.containerUnsubscribe.classList.remove('d-block');
                    _this.containerCancelled.classList.add('d-block');
                }
                else {
                    _this.containerUnsubscribe.classList.remove('d-block');
                    _this.containerNotValid.classList.add('d-block');
                }
            }
            else {
                _this.containerUnsubscribe.classList.remove('d-block');
                _this.containerNotValid.classList.add('d-block');
            }
        }).catch(function (error) {
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            console.log(error);
            _this.containerLoader.classList.remove('d-block');
            _this.containerUnsubscribe.classList.remove('d-block');
            _this.containerNotValid.classList.add('d-block');
        });
    };
    return Unsubscribe;
}(Base));
export { Unsubscribe };



//////////////////
// WEBPACK FOOTER
// ./components/unsubscribe/unsubscribe.component.ts
// module id = 546
// module chunks = 0